import styled from "styled-components";

export const ApplePayPaymentContainer = styled.button`
  display: inline-block;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: buy;
  width: 100%;
  height: 48px;
  -apple-pay-button-style: black;
`;
